import React, { FC, useEffect } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'

const IndividualOpeningTradingAccountForm: FC<FormProps> = props => {
  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    delete data.data.formW9
    delete data.data.formW8BEN
    if (submit) submit(data)
  }

  const {
    formData,
    emptyValidation,
    toggleShowByName,
    toggleShowByVisualName,
    handleInputChange,
    handleSubmit
  } = useForm(props.fetchedData, config, submitForm)

  useEffect(() => {
    toggleShowByName('investmentDetails', formData?.investingOwnMoney?.value === 'false')
  },[formData?.investingOwnMoney?.value])

  useEffect(() => {
    toggleShowByName('nameOfJointAccountHolder', formData?.accountType?.value === 'jointAccount')
    toggleShowByVisualName('labelNameInfo', formData?.accountType?.value === 'jointAccount' ? 'true' : 'false')
  },[formData?.accountType?.value])

  useEffect(() => {
    toggleShowByName('nameOfEmployee', formData?.areYouSucdenEmployee?.value === 'true')
  },[formData?.areYouSucdenEmployee?.value])

  useEffect(() => {
    toggleShowByName('nameOfTheCompany', formData?.employeeOfOtherInvestmentCompany?.value === 'true')
  },[formData?.employeeOfOtherInvestmentCompany?.value])

  useEffect(() => {
    toggleShowByVisualName('nonUsPersonText', formData?.isUSPerson?.value === 'false' ? 'true' : 'false')
    toggleShowByName('isUSProducts', formData?.isUSPerson?.value === 'false')
    toggleShowByVisualName('w8ben-fileInput', formData?.isUSPerson?.value === 'false' ? 'true' : 'false')

    toggleShowByVisualName('w9-fileInput', formData?.isUSPerson?.value === 'true' ? 'true' : 'false')
    toggleShowByName('formW9', formData?.isUSPerson?.value === 'true')
  },[formData?.isUSPerson?.value])

  useEffect(() => {
    toggleShowByVisualName('w8ben-fileInput', formData?.isUSProducts?.value === 'true' ? 'true' : 'false')
    toggleShowByName('formW8BEN', formData?.isUSProducts?.value === 'true')
  },[formData?.isUSProducts?.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>{t('onboarding.forms.IndividualAccount.OpeningTradingAccountForm.title')}</FormTitle>
      </FormHeader>
      {utils.sectionBuilder(config, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          {!props.disablePrev && (
            <Button label={t('onboarding.main.backButton')} version={2} disabled={props.disablePrev} />
          )}
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default IndividualOpeningTradingAccountForm
